import { ActionIcon, Menu } from '@mantine/core';
import * as icons from '@sloyd/icons';
import classnames from 'classnames';
import { useState } from 'react';
import Color from '../Color/Color';
import Icon from '../Icon/Icon';
import Slider from '../Slider/Slider';
import { Content, Header, Reset, Wrapper } from './PopSlider.style';

export type ParamType = 'color' | 'intensity' | 'enabled';

export type PopSliderProps = {
  header: string;
  value: number;
  colorValue: string;
  iconName: string;
  hideColor?: boolean;
  position: 'left' | 'right';
  onChange: (paramType: ParamType, value: number | string) => void;
  onSet: (paramType: ParamType, value: number | string) => void;
  defaultValues: { color: string; intensity: number };
  max?: number;
  withPadding?: boolean;
};

export function PopSlider(props: PopSliderProps) {
  const {
    max = 1,
    position = 'left',
    hideColor,
    header,
    colorValue,
    value,
    iconName,
    defaultValues,
    withPadding,
  } = props;
  const [val, setVal] = useState(value);

  function onChangeSlider(newValue: number) {
    props.onChange('intensity', newValue);
    setVal(newValue);
  }

  function onSetSlider(newValue: number) {
    props.onSet('intensity', newValue);
  }

  function onChangeColor(newValue: string) {
    props.onSet('color', newValue);
  }

  function onReset() {
    setVal(defaultValues.intensity);
    onSetSlider(defaultValues.intensity);
    onChangeColor(defaultValues.color);
  }

  const Cmp = (icons as any)[iconName];

  const transform = position === 'left' ? 'translate(-125px, 40px)' : 'translate(135px, 40px)';
  const classNameContent = classnames({
    padding: withPadding,
  });

  return (
    <Wrapper className='PopSlider-wrapper' data-testid='PopSlider-wrapper'>
      <Menu>
        <Menu.Target>
          <ActionIcon size='lg' variant='subtle' color='blue'>
            <Cmp size={20} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown style={{ position: 'absolute', transform }}>
          <Content className={classNameContent}>
            <Header>{header}</Header>
            <Reset>
              <Icon color='#ffffff44' name='IconRotate' onClick={onReset}></Icon>
            </Reset>
            {!hideColor && <Color value={colorValue} onChange={onChangeColor} />}
            <Slider
              step={0.01}
              min={0}
              max={max}
              value={val}
              onChange={onChangeSlider}
              onChangeEnd={onSetSlider}
            />
          </Content>
        </Menu.Dropdown>
      </Menu>
    </Wrapper>
  );
}

export default PopSlider;
